export default "__VITE_ASSET__DwqDRwqY__"